import format from 'date-fns/format'
import { getCompany } from '../core/cacheService'

export const DEFAULT_COMPANY_TIMEZONE = 7
export const COMPANY_TIMEZONE_DEBUG = true

const companyTimezoneCache: Record<string, number> = {}

export function normalizeCompanyTimezone(timezone: any): number {
  const parsed = Number(timezone)
  return isNaN(parsed) ? DEFAULT_COMPANY_TIMEZONE : parsed
}

export async function getCompanyTimezone(companyId: string): Promise<number> {
  if (!companyId) {
    return DEFAULT_COMPANY_TIMEZONE
  }

  if (companyTimezoneCache[companyId] !== undefined) {
    return companyTimezoneCache[companyId]
  }

  const company = await getCompany(companyId)
  const timezone = normalizeCompanyTimezone(company && company.timezone)
  companyTimezoneCache[companyId] = timezone
  return timezone
}

export function toCompanyDate(value: any = new Date(), timezone: number = DEFAULT_COMPANY_TIMEZONE): Date {
  const date = new Date(value)
  const timezoneMinutes = normalizeCompanyTimezone(timezone) * 60
  return new Date(date.getTime() + ((timezoneMinutes + date.getTimezoneOffset()) * 60 * 1000))
}

export function formatCompanyDate(value: any, pattern: string, timezone: number): string {
  return format(toCompanyDate(value, timezone), pattern)
}

export function logCompanyTimezone(label: string, payload: Record<string, any>) {
  if (!COMPANY_TIMEZONE_DEBUG) {
    return
  }

  console.log(`[company timezone] ${label}`, payload)
}
